// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"28edad10","577":"dd5106a1","621":"f379de08"}[chunkId] + ".chunk.js";
};